import get from 'lodash/get';

export const getRequestFunction = (
  request: QueueRequest
): ('group_start' | 'group_end' | (() => void)) | undefined => {
  if (typeof request === 'string' || typeof request === 'function') return request;
  if (!request?.fn) return;

  const windowFn = get(window, request.fn);
  if (typeof windowFn !== 'function') return;

  const params: any[] = [];
  if (Array.isArray(request.params)) {
    request.params.forEach((param: any) => {
      if (param?.fn) {
        const windowSubFn = get(window, param.fn) as Window[any];
        if (typeof windowSubFn !== 'function') return;

        // @ts-ignore
        params.push(windowSubFn(...param.params));
      } else {
        params.push(param);
      }
    });
  }

  let scope = window;
  if (request.scope) {
    scope = get(window, request.scope) || window;
  }

  return () => windowFn.apply(scope, params);
};
